/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import Yup from '../../../../i18n/yup';
import ImageUploader from '../ImageUploader';
import fetch from '../../../../utils/fetcher';
import useStyles from './styles';

const validationSchema = Yup.mixed().isValidImage();

const ImageContainer = ({
  id,
  title,
  text,
  hint,
  value,
  setFieldValue,
  setFieldError,
  uploadUrl,
  getImagePath,
}) => {
  const [uploading, setUploading] = useState(false);
  const { t } = useTranslation(['translation']);
  const classes = useStyles();

  const uploadImage = async (id, file) => {
    if (!file) {
      return setFieldValue(id, null);
    }
    try {
      await validationSchema.validate(file);
    } catch (error) {
      setFieldError(id, t(`COMMON.${error.message}`));
      throw error;
    }
    setUploading(true);
    setFieldError(id);
    const formData = new FormData();
    formData.append('file', file);
    fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        setUploading(false);
        setFieldValue(id, data)
      })
      .catch((error) => {
        setUploading(false);
        setFieldError(id, t(`COMMON.${error.errorCode}`));
        throw error;
      });
  };

  return (
    <>
      <ImageUploader
        id={id}
        value={getImagePath(value)}
        setFieldValue={uploadImage}
        title={title}
        text={text}
        hint={hint}
      />
      {uploading && (
        <div className={classes.uploadingIconWrapper}>
          <FontAwesomeIcon icon={faSpinner} pulse />
        </div>
      )}
    </>
  );
};

ImageContainer.defaultProps = {
  value: null,
};

ImageContainer.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  value: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  uploadUrl: PropTypes.string.isRequired,
  getImagePath: PropTypes.func.isRequired,
};

export default ImageContainer;